
export default {
  name: 'AboutMenu',
  data() {
    return {
      links: [
        {
          route: 'magasin-excideuil',
          label: 'components.aboutMenu.ourShowroom',
        },
        {
          route: 'qui-sommes-nous-partenaires',
          label: 'components.aboutMenu.ourPartners',
        },
      ],
    }
  },
}
